// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrollable-container {\r\n  overflow: auto;\n}\n.b-button {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\n}\n[dir] .b-button {\r\n  border-radius: 50%;\r\n  padding: 0.25rem;\r\n  text-align: center;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
